module.exports = "<div class=\"page-canvas\">\n  <div class=\"page-404-canvas\">\n  </div>\n</div>\n"